import {post} from '../../../util/api'
import * as type from './type'
import * as selector from './selector'
import * as processSelector from '../../process/state/instance-detail/selector'

export const getFeedbackRequest = () => ({
    type: type.GET_FEEDBACK_REQUEST,
})

export const toggleLowNpsReason = (name, value) => ({
    type: type.TOGGLE_LOW_NPS_REASON,
    payload: {
        name,
        value,
    },
})

export const saveLowNpsReasonRequest = () => ({
    type: type.SAVE_LOW_NPS_REASON_REQUEST,
})

export const saveLowNpsReasonSuccess = (feedback) => ({
        type: type.SAVE_LOW_NPS_REASON_SUCCESS,
        payload: {
            feedback,
        },
    });

export const saveLowNpsReasonError = (error) => ({
    type: type.SAVE_LOW_NPS_REASON_ERROR,
    payload: {
        error,
    },
})

export const getFeedbackDetailsSuccess = (feedback) => {
    const { created, lowScoreReason, score } = feedback;

    return ({
        type: type.GET_FEEDBACK_DETAILS_SUCCESS,
        payload: {
            feedbackCreated: created,
            lowScoreReason,
            feedbackScore: score,
        },
    });
}


export const getFeedbackDetailsError = (error) => ({
    type: type.GET_FEEDBACK_DETAILS_ERROR,
    payload: {
        error,
    },
})

export const saveLowNpsReason = () => (dispatch, getState) => {
    const state = getState()
    const feedbackId = processSelector.selectProcessContext(state).feedbackId

    dispatch(saveLowNpsReasonRequest())
    const request = {feedbackId, lowNpsReasonList: selector.selectLowNpsReasonList(state)}
    post('/api/promoter/feedback/reason', request)
        .then((feedback) => {
            dispatch(saveLowNpsReasonSuccess(feedback))
        })
        .catch(error => {
            dispatch(saveLowNpsReasonError(error))
        })
}

export const getFeedback = () => (dispatch, getState) => {
    const state = getState();
    const feedbackId = processSelector.selectProcessContext(state).feedbackId;

    dispatch(getFeedbackRequest());
    return post('/api/promoter/feedback/find-by-id', {feedbackId})
        .then((feedback) => {
            dispatch(getFeedbackDetailsSuccess(feedback));
        })
        .catch(error => {
            dispatch(getFeedbackDetailsError(error));
        });
}







// WEBPACK FOOTER //
// ./src/modules/feedback/state/action.js